// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinnerSmall_container__2MN6f","loadingSpinner":"LoadingSpinnerSmall_loadingSpinner__icbDO"};